<template>
  <div class="row row-deck">
    <div class="col-12 col-sm-8 flex-column order-1 order-sm-0">
      <div class="block">
        <ul class="nav nav-tabs nav-tabs-block js-tabs-enabled" data-toggle="tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :class="post.type == 3 ? 'active' : ''" href="javascript:void(0)" v-on:click="post.type = 3">
              <h3 class="block-title">Artikel zelf schrijven</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="post.type == 4 ? 'active' : ''" href="javascript:void(0)" v-on:click="post.type = 4">
              <h3 class="block-title">Artikel laten schrijven + &euro;15</h3>
            </a>
          </li>
        </ul>
        <div class="block-content">
          <p class="font-size-sm text-muted d-flex flex-wrap gap-x-3 gap-y-1 mb-1">
            <span v-if="post.type === 3"><i class="fa fa-check text-success mr-2"></i> Minimaal 350 woorden </span>
            <span v-if="post.type === 4"><i class="fa fa-check text-success mr-2"></i> Wij schrijven tenminste 350 woorden </span>
            <span><i class="fa fa-check text-success mr-2"></i> Maximaal 2 uitgaande links </span>
            <span v-if="post.type === 3"><i class="fa fa-check text-success mr-2"></i> Binnen 48 uur gepubliceerd </span>
            <span v-if="post.type === 4">
              <i class="fa fa-check text-success mr-2"></i>
              Uw artikel wordt opgeleverd binnen 5 werkdagen, nadat de tekstschrijver dit artikel geclaimd heeft.
              <i
                class="fas fa-question-circle ml-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Gemiddeld binnen 2 uur en 24 minuten geclaimd"
                data-original-title="Gemiddeld binnen 2 uur en 24 minuten geclaimd"
              ></i>
            </span>
          </p>
          <p class="font-size-sm text-muted d-flex flex-wrap gap-x-3 gap-y-1">
            <span><i class="fa fa-times text-danger mr-2"></i> Geen Adult / 18+ </span>
            <span><i class="fa fa-times text-danger mr-2"></i> Geen www. in de titel of anchor </span>
            <span><i class="fa fa-times text-danger mr-2"></i> Geen duplicate content</span>
            <span><i class="fa fa-times text-danger mr-2"></i> Commerciële / reclame artikelen niet toegestaan</span>
          </p>

          <div class="form-group">
            <bs-input
              :label="post.type == 3 ? 'Titel' : 'Titel suggestie'"
              name="title"
              classname="js-maxlength"
              maxlength="90"
              :maxlengthShow="true"
              v-model="post.title"
            ></bs-input>
          </div>
        </div>
        <div class="block-content tab-content">
          <div class="tab-pane" :class="post.type == 3 ? 'active' : ''" id="zelf-schrijven" role="tabpanel">
            <div class="form-group">
              <label>Artikel</label>
              <bs-editor v-model="post.description" />
              <div v-if="editor_error" class="invalid-feedback animated fadeIn d-block">{{ $t(editor_error) }}</div>
            </div>
          </div>
          <div class="tab-pane" :class="post.type == 4 ? 'active' : ''" id="laten-schrijven" role="tabpanel">
            <div class="form-group">
              <bs-textarea
                label="Korte omschrijving"
                rows="3"
                classname="js-maxlength"
                maxlength="150"
                :maxlengthShow="true"
                placeholder="Beschrijf hier uw wensen voor het artikel"
                name="request_data.description"
                v-model="post.request_data.description"
              ></bs-textarea>
            </div>
            <div class="form-group">
              <bs-input
                label="Linktekst 1"
                name="request_data.title"
                classname="js-maxlength"
                maxlength="42"
                :maxlengthShow="true"
                v-model="post.request_data.title"
              ></bs-input>
            </div>
            <div class="form-group">
              <bs-input label="Url 1" name="request_data.url" v-model="post.request_data.url"></bs-input>
            </div>
            <div class="form-group">
              <bs-input
                label="Linktekst 2 (niet verplicht)"
                name="request_data.optional_title"
                classname="js-maxlength"
                maxlength="42"
                :maxlengthShow="true"
                v-model="post.request_data.optional_title"
              ></bs-input>
            </div>
            <div class="form-group">
              <bs-input label="Url 2 (niet verplicht)" name="request_data.optional_url" v-model="post.request_data.optional_url"></bs-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 flex-column order-0 order-sm-1">
      <div class="block w-100">
        <div class="block-header block-header-default">
          <h3 class="block-title">Acties</h3>
        </div>
        <div class="block-content">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                :class="{ 'is-invalid': errors['guidelines'] && errors['guidelines'].length > 0 }"
                type="checkbox"
                value="1"
                id="guidelines"
                name="guidelines"
                v-model="guidelines"
              />
              <label class="form-check-label font-weight-normal" for="guidelines"
                >Ik heb de <a href="/richtlijnen-publicatie-artikel-seotool.pdf" target="_blank">voorwaarden en richtlijnen</a> voor het schrijven van
                een artikel gelezen en begrepen</label
              >
              <div v-if="errors['guidelines'] && errors['guidelines'].length > 0" class="invalid-feedback animated fadeIn">
                {{ errors['guidelines'][0] }}
              </div>
            </div>
          </div>
          <div class="form-group d-flex">
            <button type="submit" class="btn btn-primary" v-on:click="submit">{{ this.item ? 'Opslaan' : 'Toevoegen' }}</button>
          </div>
        </div>
      </div>
      <div v-if="Object.values(errors).length > 0" class="block block-themed w-100">
        <div class="block-header block-header-default bg-danger">
          <h3 class="block-title">We zijn er bijna!</h3>
        </div>
        <div class="block-content">
          <p class="mb-0">De volgende punten moeten nog worden gedaan voor het artikel gepubliceerd kan worden:</p>
          <ul>
            <template v-for="error in errors">
              <li v-for="message in error">
                {{ message }}
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="block w-100">
        <div class="block-header block-header-default">
          <h3 class="block-title">Informatie</h3>
        </div>
        <div class="block-content">
          <div class="form-group">
            <bs-select
              label="Blog"
              name="blog_id"
              classname="js-select2"
              :options="
                $_.sortBy(
                  blogs.map((blog) => {
                    return {
                      name: $options.filters.capitalize(blog.name),
                      value: blog.id,
                    };
                  }),
                  (s) => s.name
                )
              "
              v-model="post.blog_id"
            ></bs-select>
          </div>
          <div class="form-group">
            <bs-select
              label="Categorie"
              name="page_id"
              classname="js-select2"
              :options="
                pages.map((item) => {
                  return {
                    value: item.id,
                    name: $options.filters.capitalize(item.title),
                  };
                })
              "
              :disabled="(!post.blog_id && !pages.length) || pages.length === 0"
              v-model="post.page_id"
              :addon="price"
              addonTooltip="Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend"
            ></bs-select>
          </div>
          <div class="form-group">
            <bs-input
              label="Activeer artikel per"
              name="start_date"
              classname="js-flatpickr flatpickr-input bg-white"
              :minDate="moment().format('YYYY-MM-DD')"
              v-model="post.start_date"
            ></bs-input>
          </div>

          <!-- Image selector -->
          <bs-image-picker
            v-model="post.image"
            name="image"
            :saved="false"
            :disabled="post.type === 4"
            ref="imagePicker"
            :placeholder="
              post.type === 4 ? 'De tekstschrijver selecteert een passende afbeelding' : 'Typ een woord in om te zoeken in onze database.'
            "
          ></bs-image-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import EventBus from '../plugins/vue-event-bus';

export default {
  props: {
    blogs: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  data: () => {
    return {
      pages: [],
      categories: [],
      errors: [],
      links: [],

      guidelines: true,

      post: {
        // Blogs
        blog_id: null,
        page_id: null,
        title: '',
        description: '',
        image: null,
        type: 3,
        start_date: moment().format('YYYY-MM-DD'),

        // Type 4
        request_data: {
          description: '',
          title: '',
          url: '',
          optional_title: null,
          optional_url: null,
        },
      },
    };
  },
  created: function() {
    let storage = localStorage.getItem('post');
    const urlParams = new URLSearchParams(window.location.search);
    this.post.blog_id = urlParams.get('blog_id');

    if (this.item) {
      console.log(this.item);
      this.post = this.item;
      this.post.request_data = this.item.request_data ?? {
        description: '',
        title: '',
        url: '',
        optional_title: null,
        optional_url: null,
      };
    } else if (storage && JSON.parse(storage).expires_at >= moment().toISOString()) {
      this.post = JSON.parse(storage).post;
    }
  },
  computed: {
    editor_error: function() {
      if (this.errors && this.errors['description']) {
        return this.errors['description'][0];
      }
    },
    price: function() {
      var price = null;
      if (this.post.blog_id) {
        var blog = this.blogs.find((blog) => {
          return blog.id == this.post.blog_id;
        });

        price = blog.discount_price ?? blog.post_price;
      }

      return price ? this.$options.filters.currency(price) : price;
    },
  },
  watch: {
    post: {
      deep: true,
      handler: function() {
        if (this.item) return;
        localStorage.setItem(
          'post',
          JSON.stringify({
            expires_at: moment()
              .add(1, 'hour')
              .toISOString(),
            post: this.post,
          })
        );
      },
    },
    'post.blog_id': function() {
      this.pages = [];
      this.categories = [];
      if (this.post.blog_id) {
        axios.get(route('blogs.pages.index', this.post.blog_id)).then((response) => {
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              this.pages = response.data.data;
            }
          }
        });
      }
    },
    'post.type': function(newValue) {
      if (newValue === 3) {
        this.post.request_data = {
          description: '',
          title: '',
          url: '',
          optional_title: null,
          optional_url: null,
        };
      }

      if (newValue === 4) {
        this.post.image = null;
        this.post.description = '';
        this.$refs.imagePicker.reset();
      }

      setTimeout(() => {
        window.One.helpers(['core-bootstrap-tooltip']);
      }, 100);
    },
  },
  methods: {
    submit: function() {
      // Validate root
      var errors = {};
      if (this.post.type == 3) {
        // Check if text minimum 350 words?
        let text = this.post.description.replace(/<[^>]+>/g, '');
        if (text.trim().split(/\s+/).length < 347) {
          if (!errors['description']) errors['description'] = [];
          errors['description'].push('Het artikel moet minimaal 350 woorden bevatten.');
        }

        // Check max 2 links
        var doc = document.createElement("html");
        doc.innerHTML = this.post.description;
        var links = doc.getElementsByTagName("a");
        if (links && links.length > 2) {
          if (!errors['description']) errors['description'] = [];
          errors['description'].push('Het artikel mag maximaal 2 linkjes bevatten.');
        }

        if (links) {
          Array.from(links).forEach((link) => {
            if (link.text.length > 42) {
              if (!errors['description']) errors['description'] = [];
              errors['description'].push('De anchors mogen maximaal 42 tekens bevatten.');
            }
          });
        }

        if (text.includes('https://')) {
          if (!errors['description']) errors['description'] = [];
          errors['description'].push('Het artikel mag geen `https://` bevatten.');
        }

        if (text.includes('www.')) {
          if (!errors['description']) errors['description'] = [];
          errors['description'].push('Het artikel mag geen `www.` bevatten.');
        }

        if (!this.guidelines) {
          if (!errors['guidelines']) errors['guidelines'] = [];
          errors['guidelines'].push('Je moet de richtlijnen gelezen hebben');
        }
      }

      this.errors = errors;

      if (Object.keys(this.errors).length === 0) {
        axios
          .post(route('cart.update'), {
            id: this.item?.id,
            blog_id: this.post.blog_id,
            link_id: null,
            post_id: null,
            page_id: this.post.page_id,
            title: this.post.title,
            description: this.post.description,
            image: this.post.image,
            type: this.post.type,
            start_date: this.post.start_date,
            period: 1,
            request_data: this.post.request_data,
          })
          .then((response) => {
            if (response.status == 200 && response.data) {
              this.errors = response.data.errors;
              if (response.data.success) {
                EventBus.publish('cart.refresh');
                localStorage.removeItem('post');
                this.$notify({
                  group: 'main',
                  type: 'success',
                  title: 'Het artikel is toegevoegd en staat in de winkelwagen klaar voor betaling',
                });
                window.location = route('cart.index');
              }
            }
          });
      }
    },
  },
};
</script>
